import React from 'react';

const Loadingscreen = () => {
    return (
        <div className="loader">
            <span className="circle">
                <img
                    className="logo_img mobileHidden"
                    src={window.location.origin + "/assets/images/lumisoft.png"}
                    alt=""
                    style={{
                        padding: 25
                    }}
                />
                <div className="scircle"></div>
                <div className="scircle"></div>
            </span>
        </div>
    );
};

export default Loadingscreen;